import React from 'react';
import { Icon, Loading } from 'components';
import { Checkbox, Paper } from 'e100-react-components';
import useStyles from './useStyles';
import { useHandler } from './hooks/useHandler';
import { useIsLoadingGeoPosition, useUserGeoPosition } from 'store/features/user/selectors/useUserGeoPosition';
import isMobileDevice from 'common/utils/isMobileDevice';
import { Props as ControlProps } from '../index';

export const MyLocation = ({ showLocationControl }: Props) => {
  const classes = useStyles({ isMobile: isMobileDevice });
  const handler = useHandler();
  const geoPosition = useUserGeoPosition();
  const isLoading = useIsLoadingGeoPosition();

  if (!showLocationControl) {
    return null;
  }

  return (
    <Paper
      classes={{
        root: classes.container,
      }}
      square={false}
    >
      <Checkbox
        isChecked={!!geoPosition}
        classes={{
          checkbox: {
            root: classes.checkBoxBase,
          },
          formControlLabel: {
            root: classes.checkBoxLabel,
          },
        }}
        icon={<Icon kind="myLocation" color="secondary" />}
        checkedIcon={
          <>{isLoading ? <Loading marginLeft={0} marginRight={0} /> : <Icon kind="myLocation" color="primary" />}</>
        }
        onChange={(_, isChecked) => handler(isChecked)}
      />
    </Paper>
  );
};

interface Props extends Pick<ControlProps, 'showLocationControl'> {}
